<template>
	<div class="prize">
		<div class="container">
			<h2><img src="../assets/heading-prize.svg" alt="Win"/> a holiday in Japan for two</h2>
			<p>
				Japan is a kaleidoscopic spectacle with endless wonders. It’s hard not to be dazzled by cherry blossoms, neon cities, sacred temples, and powder white snow.<br><br>
				But take a step back and you’ll begin to see the bigger picture, other jewels that make up the soul of Japan. <br><br>
				In regions far and away, magical moments are taking place in wild forests and majestic oceans.<br class="desktop-only"> All that’s missing is you.<br>
			</p>
			<div class="blocks">
				<nav>
					<ul>
						<li><a href="#" :class="{'active': activeBlock === 'howto'}" @click.prevent="activeBlock = 'howto'">How to enter</a></li>
						<li><a href="#" :class="{'active': activeBlock === 'prize'}" @click.prevent="activeBlock = 'prize'">The Prize</a></li>
					</ul>
				</nav>
				<div :class="{'block': true, 'block--prize': true, 'block--active': activeBlock === 'prize'}">
					<h3>The Prize</h3>
					<p>We will give one lucky person the chance to experience all of Japan’s colourful moments with a friend.<br><br>
					The winner will embark on a 12-day Southern Japan Experience trip (excluding flights) from Intrepid Travel valued at AUD $12,170.<br><br>
					Itinerary Highlights:<br></p>
					<ul>
						<li>The art island of Naoshima </li>
						<li>Nagasaki and Osaka</li>
						<li>Hiking through lush mountains and deep gorges</li>
						<li>Exploring mysterious cedar forests on Yakushima </li>
						<li>Relaxing in onsen</li>
					</ul>
					<div class="gallery">
						<a href="" @click.prevent="$root.dispatchEvent('prizeClick', {prizeId: 1}); showImage(1);"><img src="../assets/photo-01.jpg" alt=""></a>
						<a href="" @click.prevent="$root.dispatchEvent('prizeClick', {prizeId: 2}); showImage(2);"><img src="../assets/photo-02.jpg" alt=""></a>
						<a href="" @click.prevent="$root.dispatchEvent('prizeClick', {prizeId: 3}); showImage(3);"><img src="../assets/photo-03.jpg" alt=""></a>
						<div><a href="https://www.intrepidtravel.com/au/search?country=Japan" target="_blank" @click="$root.dispatchEvent('partnerClick');"><img src="../assets/logo-intrepid.png" alt=""></a></div>
					</div>
				</div>
				<div :class="{'block': true, 'block--howto': true, 'block--active': activeBlock === 'howto'}">
					<h3>How to enter</h3>
					<ol>
						<li>Choose which experience you’d like to witness.</li>
						<li>See how all the colourful moments come together.</li>
						<li>When the ‘Golden Moment’ appears, grab it for your chance to win a holiday in Japan for two!</li>
					</ol>
					<a href="#mfmm-moments" class="btn"><svg-arrow/>Begin the Show <svg-arrow/></a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SvgArrow from './SvgArrow';

export default {
	name: 'app',
	components: { SvgArrow },
	data () {
		return {
			'activeBlock': 'howto',
		};
	},
	methods: {
		showImage (url) {
			this.$store.commit('lightboxImage', url);
			this.$emit('showLightbox');
		},
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../assets/_mixins.less';
	@import (reference) '../assets/_breakpoints.less';

	.prize { margin-bottom: -80px; background: transparent url(../assets/bg-prize.jpg) 50% 0 / 100% no-repeat; color: white;  text-align: center; }
	.container { max-width: 830px; margin: 0 auto; transform: translateY(-100px); }
	h2 { font-size: 36px; font-weight: 600; text-transform: uppercase;
		img { transform: translate(-10px, 15px); }
	}
	h2 + p { margin-top: 40px; }
	.blocks { display: flex; justify-content: space-between; margin-top: 50px;
		nav { display: none; }
		.block { width: 45%;
			&:first-of-type { max-width: 385px; }
			&:last-of-type { max-width: 345px; }
			h3 { margin-bottom: 35px; font-weight: 600; font-size: 30px; }
			p { text-align: left; }
			.gallery { display: flex; justify-content: space-between; flex-wrap: wrap; margin-top: 20px;
				a { width: 30%; }
				img { border: 5px solid white; }
				div { width: 100%; margin-top: 27px; text-align: center; }
			}
			ul { text-align: left; list-style: disc; margin-left: 2em; }
			ol { text-align: left; list-style: none; counter-reset: list;
				li { position: relative; margin-bottom: 45px; }
				li:before { position: absolute; left: -40px; top: -14px; content: counter(list, decimal) ") "; counter-increment: list; font-weight: 500; font-size: 40px; }
			}
			&__note { margin-top: -20px; font-size: 14px; }
			a.btn { display: block; width: 100%; margin-top: 35px; padding: 15px 0 10px; border-radius: 10px; background-color: #E60411; color: white; font-weight: 500; text-transform: uppercase; font-size: 18px;
				svg { fill: white; width: 30px; vertical-align: middle;
					&:first-child { margin-right: 17px; }
					&:last-child { margin-left: 17px; }
				}
			}
		}
	}

	@media @tablet {
		.container { padding-left: 2em; padding-right: 2em; }
	}

	@media @mobile {
		.desktop-only { display: none; }
		.prize { margin-bottom: 0; height: auto; background: transparent url(../assets/bg-prize-mobile.jpg) 50% 0 / cover no-repeat; color: white;  text-align: center; }
		.container { transform: translateY(0); padding-top: 2em; padding-bottom: 40px; }
		h2 { font-size: 22px;
			img { max-width: 70px; transform: translate(-10px, 5px); }
		}
		h2 + p { text-align: left; max-width: 85%; margin: 40px auto 0; }
		.blocks { position: relative; width: 85%; margin: 40px auto 0; padding-top: 70px; flex-direction: row-reverse; background-color: #fff;
			nav { width: 100%; display: block; .top-left();
				ul { display: flex; width: 100%;
					li { width: 50%;
						a { display: block; padding: 16px 0 10px; font-weight: 600; font-size: 24px; background-color: #DD0700; color: white;
							&.active { background-color: #fff; color: black; }
						}
					}
				}
			}
			.block { display: none; width: 100%; padding: 25px; background-color: #fff; color: black;
				&--active { display: block; }
				&:first-of-type, &:last-of-type { width: 100%; max-width: unset; }
				h3 { display: none; }
				ol {
					li { margin-left: 40px; }
				}
				.gallery {
					a { width: 33%; height: auto; }
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/PrizeSection.vue